import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
	'use strict';

	angular
        .module('riskSelfAssessmentAssessControllers')
        .factory('riskSelfAssessmentAssessService', service);

	service.$inject = ['$http', '$q'];

	function service($http, $q) {
	    var baseUrl = environment.apiUrl + '/Pilot/api/RiskSelfAssessment';
		var baseReportUrl = environment.apiUrl + '/ReportPilot/api/RiskSelfAssessment';

		var service = {
		    assessRiskByAssessor       : assessRiskByAssessor,
		    getRisksToAssess           : getRisksToAssess,
            getRiskEvents              : getRiskEvents,
		    resetAnswers               : resetAnswers,
            submit                     : submit,
            summaryExportToExcel       : summaryExportToExcel,
            summaryExportToReport      : summaryExportToReport,
			isQuestionValid			   : isQuestionValid
		};
		return service;

		////////////

	    // Get Risks To Assess
		function getRisksToAssess(assessorId) {
		    var reqUrl = baseUrl + '/Assessment';
		    if (assessorId != null) {
		        reqUrl = baseUrl + '/Assessor@' + assessorId + '/Assessment';
		    }

		    return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

        // Assess Risk By Assessor
		function assessRiskByAssessor(riskToAssess, authenticatedAssessorID) {
		    var reqUrl = baseUrl + '/Assessment/Risk/' + riskToAssess.Risk.RiskID;

		    if (authenticatedAssessorID != null) {
		        reqUrl = baseUrl + '/Assessor@' + authenticatedAssessorID + '/Assessment/Risk/' + riskToAssess.Risk.RiskID;
		    }

		    return $http.post(reqUrl, riskToAssess)
                        .then(function (response) {
                            return response.data;
                        });
		}

        // Risk Events
        function getRiskEvents(risk) {
            var url = environment.apiUrl + '/Pilot/api/Risk/' + risk.RiskID + '/RiskEvent';
            return $http.get(url)
                        .then(function (response) {
                            return response.data;
                        });
        }

	    // Reset answers
        function resetAnswers(risk, authenticatedAssessorID) {

		    var reqUrl = baseUrl + '/Assessment/Reset/' + risk.RiskID;
		    if (authenticatedAssessorID !=null) {
		        reqUrl = baseUrl + '/Assessor@' + authenticatedAssessorID + '/Assessment/Reset/' + risk.RiskID;
		    }
		    return $http.post(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Submit Assessment
        function submit(assessorID) {

		    var reqUrl = baseUrl + '/Assessment/Submit';
		    if (assessorID != null) {
		        reqUrl = baseUrl + '/Assessor@' + assessorID + '/Assessment/Submit';
		    }
		    return $http.post(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Summary - Export To Excel
        function summaryExportToExcel(assessorID) {
            var reqUrl = baseReportUrl + '/SummaryExportToExcel';
            if (assessorID != null) {
                reqUrl = baseReportUrl + '/Assessor@' + assessorID + '/SummaryExportToExcel';
            }

            return $http.post(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Summary - Export To Report
        function summaryExportToReport(assessorID) {
            var reqUrl = baseReportUrl + '/SummaryExportToReport';
            if (assessorID != null) {
                reqUrl = baseReportUrl + '/Assessor@' + assessorID + '/SummaryExportToReport';
            }


		    return $http.post(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

		function isQuestionValid(question) {
			var nbAnswered = false;
			_.each(question.RiskAssessmentAnswers, function (answer) {
				if (answer.AssessorValue && answer.AssessorValue.length > 0) {
					nbAnswered++;
				}
			});
			return nbAnswered >= question.MinMandatoryAnswer;
		}
	}
})();
